import {ActionCreatorWithoutPayload, ActionCreatorWithPayload, createAction} from '@reduxjs/toolkit';

export interface IUIActionTypes {
  SET_INITIAL_PATH: string;
  ROUTE_CHANGE: string;
  TOGGLE_NAV_COLLAPSED: string;
  TOGGLE_CHAT_COLLAPSED: string;
  TOGGLE_APP_DRAWER: string;
  SHOW_MESSAGE: string;
  HIDE_MESSAGE: string;
}

export const UI: IUIActionTypes = {
  SET_INITIAL_PATH: 'ui/setInitialPath',
  ROUTE_CHANGE: 'ui/routeChange',
  TOGGLE_NAV_COLLAPSED: 'ui/toggleNavCollapsed',
  TOGGLE_CHAT_COLLAPSED: 'ui/toggleChatCollapsed',
  TOGGLE_APP_DRAWER: 'ui/toggleAppDrawer',
  SHOW_MESSAGE: 'ui/showMessage',
  HIDE_MESSAGE: 'ui/hideMessage'
}

export const showMessage: ActionCreatorWithPayload<string> = createAction<string>(UI.SHOW_MESSAGE);
export const hideMessage: ActionCreatorWithoutPayload = createAction(UI.HIDE_MESSAGE);
export const onToggleAppDrawer: ActionCreatorWithoutPayload = createAction(UI.TOGGLE_APP_DRAWER);
export const onRouteChanged: ActionCreatorWithoutPayload = createAction(UI.ROUTE_CHANGE);
export const toggleNavCollapsed: ActionCreatorWithoutPayload = createAction(UI.TOGGLE_NAV_COLLAPSED);
export const toggleChatCollapsed: ActionCreatorWithoutPayload = createAction(UI.TOGGLE_CHAT_COLLAPSED);
export const setInitialPath: ActionCreatorWithPayload<string | undefined> = createAction<string | undefined>(UI.SET_INITIAL_PATH);
